/**
 * @author Ka Wing Chin (kawing.chin@takeaway.com)
 * @class Takeaway.AutoAddProduct
 * @extends Takeaway.Product
 */

import Utils from '../lib/utils'
import Product from './product'

export default class AutoAddProduct extends Product {
  updateTotalPrice () {
    this.totalPrice = Utils.toMoney((this.price * this.count), 2)
    this.totalPricePickup = Utils.toMoney((this.pricePickup * this.count), 2)
  }
}
